export const SET_TOTAL_ACHIEVEMENT = 'SET_TOTAL_ACHIEVEMENT'
